"use client"

import { SquareUser } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareUserIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareUserIcon = component(Icon)({ as: SquareUser })
